import {RestOptions} from 'shared/_interface/rest-options.interface';
import {UNKNOWN_TYPE_NAME} from 'shared/magic';
import {IEntryType} from '../../journal/src/_interface/ientry-type';
import {slugify} from 'shared/_functions/slugify';
import {FieldGroupTypeEnum} from '../../journal/src/_interface/field-group-type.enum';

export const REST_DEFAULTS: RestOptions = {
	once: true,
	withLoader: true,
	modelValidation: null,
	logOutput: true,
	processError: true,
	apiPrefix: true,
	mockApi: false,
	fullResponse: false,
	asBlob: false,
};

export const UNKNOWN_ENTRY_TYPE: IEntryType = {
	entryTypeId: '1111',
	entryType: UNKNOWN_TYPE_NAME,
	entryColor: '#333333',
	entryTypeSlug: slugify(UNKNOWN_TYPE_NAME)
};

export const UNKNOWN_FIELD_TYPE = {
	fieldType: UNKNOWN_TYPE_NAME,
	groupType: FieldGroupTypeEnum.normal
};

export const MODAL_DEFAULTS = {
	size: 'lg',
	windowClass: 'modal-default',
	centered: true,
	backdrop: 'static'
};

export const DARK_MODAL_DEFAULTS = {
	size: 'lg',
	windowClass: 'modal-dark',
	centered: true,
	backdrop: 'static'
};

export const IGNORED_CONTENT_KEYS = [
	'id',
	'contentType',
	'modificationDate',
	'author'
];

export const CONTENT_KEYS_TO_DISPLAY = [
	'textContent',
	'fileName',
	'selected',
	'date'
];

export const TOOLTIP_HOLD_TIME = 1;
export const FROM_DATE = new Date(2000, 1, 1);
export const MIN_DATE_ISO_STRING = new Date(2000, 1).toISOString();

export const POPOVER_CONFIG: { placement: string; autoClose: boolean | 'inside' | 'outside' } = {
	autoClose: 'outside',
	placement: 'auto'
};
